import React from 'react'

import PropTypes from 'prop-types'

import css from 'routes/Menu/components/Detail/Detail.css'
import { NutritionInfo } from 'routes/Menu/components/Detail/Nutrition'
import { NutritionDisclaimerText } from 'routes/Menu/components/Detail/NutritionDisclaimerText'

const DetailPerPortion = ({ loading, recipe, numPortions }) => (
  <div className={css.sectionPanel}>
    <NutritionInfo
      nutritionValues={recipe
        .getIn(['attributes', 'nutritional_information', `for${numPortions}`])
        ?.toJS()}
      loading={loading}
    />
    <NutritionDisclaimerText numPortions={numPortions} />
  </div>
)

DetailPerPortion.propTypes = {
  numPortions: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  recipe: PropTypes.instanceOf(Object).isRequired,
}

export { DetailPerPortion }
